export function applyDisplayName(component, displayName) {
    component.displayName = displayName;
}
